import React from "react";

import {
  usePreferences,
} from "../context/PreferencesContext";

import {
  useConnectionMode,
} from "../context/ConnectionModeContext";

import {
  getConnectionModeCopy,
} from "../utils/connectionModeCopy";

export default function ConnectionModeStatusBadge() {
  const {
    preferences,
  } = usePreferences();

  const copy =
    getConnectionModeCopy(
      preferences.language
    );

  const {
    state,
  } = useConnectionMode();

  const localSelected =
    state.requestedMode ===
    "local";

  const disconnected =
    state.effectiveMode ===
    "disconnected";

  const label =
    !state.ready ||
    state.loading
      ? copy.checking
      : disconnected
        ? copy.disconnected
        : state.reason ===
            "local_capability_limited"
          ? copy.limited
          : localSelected
            ? copy.local
            : copy.online;

  return (
    <div
      aria-live="polite"
      title={`${copy.selected}: ${
        localSelected
          ? copy.local
          : copy.online
      }`}
      style={{
        position: "fixed",
        top:
          "max(calc(env(safe-area-inset-top) + 8px), 8px)",
        right: 12,
        zIndex: 125,
        display: "flex",
        alignItems: "center",
        gap: 7,
        maxWidth:
          "min(72vw, 290px)",
        padding:
          "6px 10px",
        borderRadius: 999,
        border:
          disconnected
            ? "1px solid rgba(255,92,92,0.48)"
            : localSelected
              ? "1px solid rgba(255,184,78,0.46)"
              : "1px solid rgba(73,238,255,0.45)",
        background:
          "rgba(2,10,18,0.86)",
        color: "#effcff",
        boxShadow:
          disconnected
            ? "0 0 15px rgba(255,70,70,0.20)"
            : localSelected
              ? "0 0 15px rgba(255,165,55,0.18)"
              : "0 0 15px rgba(0,225,255,0.18)",
        backdropFilter:
          "blur(10px)",
        fontSize: 11,
        letterSpacing:
          "0.045em",
        pointerEvents: "none",
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 7,
          height: 7,
          borderRadius: "50%",
          flex: "0 0 auto",
          background:
            disconnected
              ? "#ff6868"
              : localSelected
                ? "#ffc268"
                : "#70f5ff",
          boxShadow:
            disconnected
              ? "0 0 8px #ff6868"
              : localSelected
                ? "0 0 8px #ffc268"
                : "0 0 8px #70f5ff",
        }}
      />

      <span
        style={{
          overflow: "hidden",
          textOverflow:
            "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </span>
    </div>
  );
}
